import {ValidateState} from 'lib.common';
import {PtrnCampoEditableString, PtrnCampoValidarResult} from '../../patronTypes';
import {PtrnTransformarCampoFn, PtrnValidarCampoFn} from './ptrnProcesarTypes';
import {PtrnProcesarUtilsCfg, PtrnProcesarValidacionesComunes} from './ptrnProcesarUtils';

export const ptrnValidacionString: PtrnValidarCampoFn<string | null, PtrnCampoEditableString> = (
   currValue,
   campoConfig,
   estado
) => {
   const validateResult: PtrnCampoValidarResult = PtrnProcesarUtilsCfg.NoErrResult();
   //1. control de errores q deben evitar actualizacion del estado, x ejemplo si es numerico no deberia actualizar si el nuevo valor contiene letras o si excede los caracteres configurados
   //|---> si existe error hacer result.push(PtrnProcesarUtilsCfg.ErrValidar(<mensaje_error>)) y retornar result
   if (
      campoConfig.ignorarCaracteres &&
      PtrnProcesarValidacionesComunes.hasAnyCharacter(currValue, campoConfig.ignorarCaracteres)
   ) {
      const mensajeCaracteres = Array.isArray(campoConfig.ignorarCaracteres)
         ? `Caracteres prohibidos: ${campoConfig.ignorarCaracteres.join(',')}`
         : `No se permiten caracteres que coincidan con: ${campoConfig.ignorarCaracteres}`;

      validateResult.errores.push(
         PtrnProcesarUtilsCfg.ErrValidar(`El carácter ingresado no es válido. ${mensajeCaracteres}`)
      );
      validateResult.gravedadMaxima = ValidateState.ERROR;
      return validateResult;
   }

   return validateResult;
};

export const ptrnTranformarString: PtrnTransformarCampoFn<any, PtrnCampoEditableString> = (
   originalValue,
   campoConfig,
   estado
) => {
   let newValue = originalValue || '';

   if (campoConfig.minus) {
      newValue = originalValue.toLowerCase();
   }
   if (campoConfig.mayus) {
      newValue = newValue.toUpperCase();
   }
   if (campoConfig.esId) {
      newValue = newValue.toUpperCase().trim();
   }

   return newValue;
};
